import { useNavigate } from 'react-router-dom';
import { LayoutGrid, Settings } from 'lucide-react';
import { useWorkspaceSidebar } from '@/components/layout/WorkspaceSidebarContext';
import { useSettingsOptional } from '@/components/layout/SettingsContext';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import SidebarUserMenu from '@/components/layout/SidebarUserMenu';
import WorkspaceSidebarLogo from '@/components/layout/WorkspaceSidebarLogo';
import {
  WORKSPACE_SIDEBAR_BG_CLASS,
  workspaceSidebarNavBtnClass,
} from '@/components/layout/workspace-layout';

const InventorySidebar = () => {
  const navigate = useNavigate();
  const { closeMobile } = useWorkspaceSidebar() ?? {};
  const settings = useSettingsOptional();

  const onNav = (fn: () => void) => {
    fn();
    closeMobile?.();
  };

  return (
    <aside
      className={cn(
        'box-border flex h-full min-h-0 w-full flex-col items-center',
        WORKSPACE_SIDEBAR_BG_CLASS,
      )}
      aria-label="Workspace navigation">
      <WorkspaceSidebarLogo />

      <nav className="flex min-h-0 w-full flex-1 flex-col items-center overflow-x-hidden overflow-y-auto px-2 pb-3 pt-1">
        <Button
          type="button"
          variant="ghost"
          className={workspaceSidebarNavBtnClass(true)}
          aria-label="Components"
          aria-current="page"
          title="Components"
          onClick={() => onNav(() => navigate('/sia/components'))}>
          <LayoutGrid
            className="h-[1.125rem] w-[1.125rem]"
            strokeWidth={1.75}
            aria-hidden="true"
          />
        </Button>
      </nav>

      <div className="flex shrink-0 flex-col items-center gap-2 px-2 pb-4 pt-2">
        <Button
          type="button"
          variant="ghost"
          className={workspaceSidebarNavBtnClass(false)}
          aria-label="Settings"
          title="Settings"
          onClick={() => {
            closeMobile?.();
            settings?.openSettings();
          }}>
          <Settings className="h-[1.125rem] w-[1.125rem]" strokeWidth={1.75} />
        </Button>
        <SidebarUserMenu />
      </div>
    </aside>
  );
};

export default InventorySidebar;
